import { render, staticRenderFns } from "./StaffReport.vue?vue&type=template&id=23f0791b&scoped=true"
import script from "./StaffReport.vue?vue&type=script&lang=ts"
export * from "./StaffReport.vue?vue&type=script&lang=ts"
import style0 from "./StaffReport.vue?vue&type=style&index=0&id=23f0791b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f0791b",
  null
  
)

export default component.exports